import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  DialogTemplateButtonComboStyleEnum
} from '@shared/components/templates/dialog-template/enums/dialog-template-button.enum';
import { ObjectNameEnum } from '@base/modules/rest/master-data-history/model/enums/object-name.enum';
import { FormControl } from '@angular/forms';
import { FieldPathResolverService } from '@shared/components/field-path-input/services/field-path-resolver.service';
import { SnackBarService } from '@base/services/snackbar.service';

@Component({
  selector: 'app-find-field-path-dialog',
  templateUrl: './find-field-path-dialog.component.html',
  styleUrls: ['./find-field-path-dialog.component.scss'],
  providers: [
    FieldPathResolverService,
  ],
})
export class FindFieldPathDialogComponent {
  ObjectNameEnum = ObjectNameEnum;
  DialogTemplateButtonComboStyleEnum = DialogTemplateButtonComboStyleEnum;

  objectFormControl = new FormControl();
  fieldPathFormControl = new FormControl();

  constructor(private snackBarService: SnackBarService,
              public dialogRef: MatDialogRef<FindFieldPathDialogComponent>) {
  }

  copy(): void {
    const fieldPath = this.fieldPathFormControl.value;

    if (!fieldPath) {
      this.snackBarService.openErrorMessage('No field path to copy');
      return;
    }

    // Try to use the modern Clipboard API first
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(fieldPath)
        .then(() => {
          this.snackBarService.openSuccessMessage('Field path copied to clipboard!');
          this.dialogRef.close();
        })
        .catch(() => {
          // Fallback to the older method if Clipboard API fails
          this.fallbackCopyToClipboard(fieldPath);
        });
    } else {
      // Fallback for older browsers or non-secure contexts
      this.fallbackCopyToClipboard(fieldPath);
    }
  }

  private fallbackCopyToClipboard(text: string): void {
    try {
      // Create a temporary textarea element
      const textArea = document.createElement('textarea');
      textArea.value = text;

      // Make it invisible
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      // Execute copy command
      const successful = document.execCommand('copy');

      // Clean up
      document.body.removeChild(textArea);

      if (successful) {
        this.snackBarService.openSuccessMessage('Field path copied to clipboard!');
        this.dialogRef.close();
      } else {
        this.snackBarService.openErrorMessage('Failed to copy to clipboard');
      }
    } catch (err) {
      this.snackBarService.openErrorMessage('Failed to copy to clipboard');
    }
  }

  static open(dialog: MatDialog): MatDialogRef<FindFieldPathDialogComponent, string> {
    return dialog.open(FindFieldPathDialogComponent, {
      width: '800px',
      data: {},
    });
  }
}
